import React, { createContext, useReducer, useEffect, useContext, useState } from 'react';

// 1. Estado inicial: Busca en localStorage, si no hay nada, arranca vacío
const initialState = {
  items: JSON.parse(localStorage.getItem('pascolo_cart')) || []
};

// 2. El Reducer: Maneja la lógica pesada de sumar/restar/limpiar
const cartReducer = (state, action) => {
  switch (action.type) {
    case 'ADD_TO_CART': {
      const newItem = action.payload;
      
      const existingItemIndex = state.items.findIndex(
        (item) => 
          item.producto_id === newItem.producto_id && 
          item.presentacion_id === newItem.presentacion_id &&
          item.maduracion === newItem.maduracion
      );

      if (existingItemIndex >= 0) {
        const updatedItems = [...state.items];
        
        // Sumamos lo que ya hay en el carrito + lo que intenta agregar
        const cantidadPropuesta = updatedItems[existingItemIndex].cantidad + newItem.cantidad;
        
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          // LA MAGIA: Nos quedamos con el número más chico entre la suma y el stock máximo
          cantidad: Math.min(cantidadPropuesta, newItem.stock_maximo)
        };
        
        return { ...state, items: updatedItems };
      } else {
        return { ...state, items: [...state.items, newItem] };
      }
    }
    
    case 'UPDATE_QUANTITY': {
      const { index, newQuantity } = action.payload;
      const updatedItems = [...state.items];
      
      // Rescate por si quedó algún ítem viejo sin la propiedad
      const maximo = updatedItems[index].stock_maximo || 99;
      
      updatedItems[index] = {
        ...updatedItems[index],
        // Blindaje extra: No puede bajar de 1, ni subir más que el máximo
        cantidad: Math.max(1, Math.min(newQuantity, maximo))
      };
      
      return { ...state, items: updatedItems };
    }

    case 'REMOVE_FROM_CART':
      return { 
        ...state, 
        items: state.items.filter((item, index) => index !== action.payload) 
      };
      
    case 'CLEAR_CART':
      return { items: [] };
      
    default:
      return state;
  }
};

// 3. Crear el Contexto
const CartContext = createContext();

// 4. El Provider que va a envolver tu App
export const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(cartReducer, initialState);
  const [isCartOpen, setIsCartOpen] = useState(false);

  // EFECTO MAGIA: Cada vez que state.items cambie, se clava en el disco del navegador
  useEffect(() => {
    localStorage.setItem('pascolo_cart', JSON.stringify(state.items));
  }, [state.items]);

  // Función helper para no tener que escribir 'dispatch' en todos lados
  const agregarAlCarrito = (item) => {
    dispatch({ type: 'ADD_TO_CART', payload: item });
  };
  const vaciarCarrito = () => {
    dispatch({ type: 'CLEAR_CART' });
  };
  return (
    // Agregamos isCartOpen y setIsCartOpen al menú disponible
    <CartContext.Provider value={{ 
      cart: state.items, 
      agregarAlCarrito, 
      dispatch,
      isCartOpen,      // <--- NUEVO
      setIsCartOpen,   // <--- NUEVO
      vaciarCarrito    // <--- NUEVO
    }}>
      {children}
    </CartContext.Provider>
  );
};

// Custom Hook para consumirlo facilísimo en cualquier componente
export const useCart = () => useContext(CartContext);